/* Salmatcha · audit pass (Oct 2026) — fail-open helpers.
   0. Re-render the "Subscription Management" nav item as a header icon + add a
      slot for the currency widget.
   1. Move the Doubly currency widget out of the bottom-left float into the header
      (desktop) or the menu drawer (mobile).
   2. Build "key highlights" on product pages from the spec lines already
      present in the product description.
   3. Sticky add-to-cart only after the real button scrolls past; keep the
      WhatsApp button clear of it.
   Everything is wrapped so a failure leaves the page exactly as it was. */
(function () {
  'use strict';
  if (window.__salAuditInit) return;
  window.__salAuditInit = true;

  var mqMobile = window.matchMedia('(max-width: 1023px)');

  /* ---------- 0. header: "Manage subscription" icon + currency slot ---------- */
  function initHeader() {
    try {
      var header = document.querySelector('header.sf-header__desktop');
      if (!header || header.querySelector('[data-sal-currency-slot]')) return;
      var iconGroup = header.querySelector('.sf-menu-logo-bar > div:last-child');
      if (!iconGroup) return;
      var accountLink = iconGroup.querySelector('a[href="/account"], a[href$="/account"], a[href*="/account?"]');
      var slot = document.createElement('div');
      slot.className = 'sal-currency-slot';
      slot.setAttribute('data-sal-currency-slot', '');
      iconGroup.insertBefore(slot, iconGroup.firstChild);
      var subNav = header.querySelector('.sf-nav > li > a[href*="account.salmatcha.com/pages"]');
      if (subNav) {
        var a = document.createElement('a');
        a.href = subNav.getAttribute('href');
        a.className = 'px-2 py-3.5 sal-sub-icon';
        a.setAttribute('aria-label', 'Manage subscription');
        a.innerHTML = '<span class="sf__tooltip-item block sf__tooltip-bottom sf__tooltip-style-2">' +
          '<svg class="w-[20px] h-[20px]" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M20 11a8 8 0 0 0-14.5-4.6M4 13a8 8 0 0 0 14.5 4.6"/><path d="M20 4v4h-4M4 20v-4h4"/></svg>' +
          '<span class="sf__tooltip-content">Manage subscription</span></span>';
        if (accountLink && accountLink.parentElement === iconGroup) iconGroup.insertBefore(a, accountLink.nextSibling);
        else iconGroup.appendChild(a);
      }
    } catch (e) { /* fail-open */ }
  }

  /* ---------- 1. currency widget → header / drawer ---------- */
  function placeCurrency() {
    try {
      var widget = document.querySelector('.doubly-float');
      if (!widget) return false;
      var target;
      if (mqMobile.matches) {
        var drawer = document.querySelector('.m-menu-drawer__content');
        if (!drawer) return false;
        target = drawer.querySelector('[data-sal-currency-slot-mobile]');
        if (!target) {
          target = document.createElement('div');
          target.className = 'sal-drawer-currency';
          target.setAttribute('data-sal-currency-slot-mobile', '');
          target.innerHTML = '<span class="sal-drawer-currency__label">Currency</span>';
          var nav = drawer.querySelector('.m-menu-drawer__navigation');
          if (nav && nav.parentElement === drawer) drawer.insertBefore(target, nav.nextSibling);
          else drawer.appendChild(target);
        }
      } else {
        target = document.querySelector('[data-sal-currency-slot]');
      }
      if (!target) return false;
      if (widget.parentElement !== target) {
        target.appendChild(widget);
        widget.classList.add('sal-currency--docked');
        document.documentElement.classList.add('sal-currency-docked');
      }
      return true;
    } catch (e) { return false; }
  }
  function initCurrency() {
    if (placeCurrency()) return;
    /* the app injects late — wait for it, give up after 8s */
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (placeCurrency() || tries > 40) clearInterval(t);
    }, 200);
  }
  mqMobile.addEventListener && mqMobile.addEventListener('change', function () { placeCurrency(); });

  /* ---------- 2. product highlights from description spec lines ---------- */
  var LABELS = [
    ['Harvest Location', 'Origin'],
    ['Harvest date', 'Harvest'],
    ['Grade', 'Grade'],
    ['Grinding', 'Grind'],
    ['Cultivar', 'Cultivar'],
    ['Certification', 'Certified'],
    ['Shading', 'Shade-grown'],
    ['Best suited for', 'Best for']
  ];
  /* every "Label:" token we know the descriptions use — displayed or not — so a
     value always ends where the next label starts */
  var ALL_LABELS = ['Contains', 'Grade', 'Best suited for', 'Harvest Location', 'Harvest date',
    'Harvest method', 'Source', 'Shading', 'Grinding', 'Cultivar', 'Certification', 'why salmatcha'];
  function parseSpecs(text) {
    text = text.replace(/\s+/g, ' ');
    var hits = [];
    ALL_LABELS.forEach(function (label) {
      var re = new RegExp(label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*:?', 'i');
      var m = re.exec(text);
      if (m) hits.push({ label: label, start: m.index, end: m.index + m[0].length });
    });
    hits.sort(function (a, b) { return a.start - b.start; });
    var out = {};
    hits.forEach(function (h, i) {
      var stop = i + 1 < hits.length ? hits[i + 1].start : text.length;
      var val = text.slice(h.end, stop).trim().replace(/[.,;:]+$/, '').trim();
      if (val) out[h.label.toLowerCase()] = val;
    });
    return out;
  }
  function initHighlights() {
    try {
      document.querySelectorAll('[data-sal-highlights]').forEach(function (box) {
        if (box.dataset.salBuilt) return;
        box.dataset.salBuilt = '1';
        var src = box.querySelector('[data-sal-highlights-src]');
        var text = src ? src.textContent : '';
        var specs = parseSpecs(text);
        var grid = box.querySelector('[data-sal-highlights-grid]');
        var items = [];
        LABELS.forEach(function (l) {
          var v = specs[l[0].toLowerCase()];
          if (!v) return;
          if (l[0] === 'Harvest Location' && !/japan/i.test(v)) v += ', Japan';
          if (l[0] === 'Harvest date') v = v.replace(/\s*\(Ichibancha\)/i, ' (ichibancha)');
          if (l[0] === 'Certification') v = v.replace(/\s*\(.*$/, '');
          items.push([l[1], v]);
          /* taste line is the brand's own claim (same wording as the comparison table) */
          if (l[0] === 'Grade' && box.dataset.salKind === 'matcha') items.push(['Taste', 'Umami-sweet, creamy, no bitterness']);
        });
        if (items.length < 2) { box.style.display = 'none'; return; }
        items = items.slice(0, 6);
        grid.innerHTML = items.map(function (it) {
          return '<div class="sal-hl"><span class="sal-hl__k">' + it[0] + '</span><span class="sal-hl__v">' + it[1] + '</span></div>';
        }).join('');
        box.classList.add('sal-highlights--ready');
      });
    } catch (e) { /* fail-open */ }
  }

  /* ---------- 3. sticky ATC: only after the real button scrolls past ----------
     The theme shows the sticky bar whenever the main Add to Cart button is not
     fully visible — on this store the subscription widget pushes the button
     below the fold, so the bar covered the purchase box on page load. This
     guard re-hides the bar while the button is still below the viewport, and
     flags <html class="sal-sticky-on"> so the chat button can move out of the way. */
  function initStickyWatch() {
    try {
      var bar = document.querySelector('.prod__sticky-atc');
      if (!bar) return;
      var mainBtn = document.querySelector('.sf-prod__info-wrapper form[action*="/cart/add"] button[name="add"], .main-product form[action*="/cart/add"] button[name="add"]');
      var headerH = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 70;
      var guarding = false;
      var apply = function () {
        if (guarding) return;
        var shown = !bar.classList.contains('translate-y-full');
        if (shown && mainBtn) {
          var top = mainBtn.getBoundingClientRect().top;
          if (top >= headerH) {           /* button is at or below the viewport → keep hidden */
            guarding = true;
            bar.classList.add('translate-y-full');
            guarding = false;
            shown = false;
          }
        }
        document.documentElement.classList.toggle('sal-sticky-on', shown);
      };
      new MutationObserver(apply).observe(bar, { attributes: true, attributeFilter: ['class'] });
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; apply(); });
      }, { passive: true });
      apply();
    } catch (e) { /* fail-open */ }
  }

  function init() {
    initHeader();
    initCurrency();
    initHighlights();
    initStickyWatch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
